export default function Template(props) {
    return <div className="NotificationTitle">Видалено історію всіх сторінок</div>
}
